import React from "react";
import { Avatar, Tooltip, Typography } from "antd";
import {
  PaperClipOutlined,
  CommentOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { PRIORITY_META, userDisplayName, userInitials, isOverdue } from "../constants";

const { Text } = Typography;

export default function TicketCard({ ticket, onClick, draggable, onDragStart, onDragEnd, dragging }) {
  const pm = PRIORITY_META[ticket.priority] || PRIORITY_META.MEDIUM;
  const overdue = isOverdue(ticket.due_date, ticket.status);
  const assignees = ticket.assignees || [];

  return (
    <div
      className={"ticket-card" + (dragging ? " dragging" : "")}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onClick={onClick}
    >
      <div className="ticket-card-number">{ticket.ticket_number}</div>
      <div className="ticket-card-title">{ticket.title}</div>

      <div className="ticket-meta-row">
        <span className="priority-pill" style={{ background: pm.bg, color: pm.color }}>
          {pm.label}
        </span>
        {(ticket.labels || []).slice(0, 2).map((label) => (
          <span
            key={label}
            style={{
              fontSize: 10,
              background: "#f1f5f9",
              padding: "2px 6px",
              borderRadius: 4,
              color: "#475569",
            }}
          >
            {label}
          </span>
        ))}
      </div>

      <div className="ticket-card-footer">
        <div className="ticket-meta-row">
          {ticket.due_date && (
            <Text type={overdue ? "danger" : "secondary"} style={{ fontSize: 12 }}>
              <CalendarOutlined /> {ticket.due_date}
            </Text>
          )}
          {(ticket.attachment_count > 0 || ticket.comment_count > 0) && (
            <>
              {ticket.attachment_count > 0 && (
                <Text type="secondary" style={{ fontSize: 12 }}>
                  <PaperClipOutlined /> {ticket.attachment_count}
                </Text>
              )}
              {ticket.comment_count > 0 && (
                <Text type="secondary" style={{ fontSize: 12 }}>
                  <CommentOutlined /> {ticket.comment_count}
                </Text>
              )}
            </>
          )}
        </div>
        <Avatar.Group maxCount={3} size="small">
          {assignees.map((u) => (
            <Tooltip key={u._id} title={userDisplayName(u)}>
              <Avatar size="small" style={{ background: "#6366f1", fontSize: 10 }}>
                {userInitials(u)}
              </Avatar>
            </Tooltip>
          ))}
        </Avatar.Group>
      </div>
    </div>
  );
}
